import React, { useCallback } from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { LeftNav } from './LeftNav';

/**
 * Build disabled fake "link" that is not clickable
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export const SubNavLink = (props) => {
    const { children, className = '' } = props;

    if (className.indexOf('disabled') > -1) {
        return <div className={className}>{children}</div>;
    }

    return <NavLink {...props} />;
};

const PageSubNav = (props) => {
    const { subNav, enterpriseId, isIBC,isPMEC, setShowMobileSubNav } = props;
    const { signedIn, roles: userRoles } = useSelector((state) => state.auth);

    const closeMobileSubNav = useCallback(() => {
        // only will exist when in mobile view
        if (setShowMobileSubNav) {
            setShowMobileSubNav(false);
        }
    }, []);

    const SubNav = useCallback(() => {
        if (signedIn) {
            return <LeftNav userRoles={userRoles} enterpriseId={enterpriseId} isIBC={isIBC} isPMEC={isPMEC} onClick={closeMobileSubNav} />;
        }

        return null;
    }, [subNav, enterpriseId, signedIn]);

    return <SubNav subNav={subNav} enterpriseId={enterpriseId} />;
};

export default PageSubNav;
